<template>
  <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.625 6.75C12.625 11.125 7 14.875 7 14.875C7 14.875 1.375 11.125 1.375 6.75C1.375 5.25816 1.96763 3.82742 3.02252 2.77252C4.07742 1.71763 5.50816 1.125 7 1.125C8.49184 1.125 9.92258 1.71763 10.9775 2.77252C12.0324 3.82742 12.625 5.25816 12.625 6.75Z" fill="#32E6BE" stroke="#32E6BE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 8.625C8.03553 8.625 8.875 7.78553 8.875 6.75C8.875 5.71447 8.03553 4.875 7 4.875C5.96447 4.875 5.125 5.71447 5.125 6.75C5.125 7.78553 5.96447 8.625 7 8.625Z" fill="#111111" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'Department',
  props: {
    size: {
      default: false
    }
  },
  computed: {

  }
};
</script>
<style scoped lang="scss">

</style>
